
import { defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import GuideNav from '../../../components/Guide/GuideNav.vue';
export default defineComponent({
  name: 'Info',
  components: { GuideNav },
  setup() {
    const store = useStore();
    const toHome = () => {
      store.commit('changeActiveHead', 'main');
    };
    return {
      toHome,
    };
  },
});
